// Module
var code = `
<i class="fa-solid fa-circle-check"></i>
<h3 class="title">Your account has been upgraded to Pro.</h3>
<p class="desc">Pro features are now active.</p>
`;
// Exports
module.exports = code;